import { useSuspenseQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { OrgInviteRecord } from "@/shared/domain/invites";

export const getQueryKey = (inviteId?: string) => {
  if (inviteId === undefined) {
    return ["invite"];
  }

  return ["invite", inviteId];
};

export function useInviteSuspenseQuery(inviteId: string | undefined) {
  const { inviteService } = useDomainServices();

  return useSuspenseQuery<OrgInviteRecord, Error>({
    queryKey: getQueryKey(inviteId),
    queryFn: ({ signal }) => {
      if (inviteId === undefined) {
        return Promise.reject(new Error("Invalid inviteId"));
      }

      return inviteService.getInvite(inviteId, signal);
    },
  });
}
